/* eslint-disable */
// Here eslint disable is use to avoid line width error
import MoreVert from "@mui/icons-material/MoreVert";
import React from "react";

const VerticalDots = (props: { className?: string }) => (
  <MoreVert className={props.className}>MoreVert</MoreVert>
);

export { VerticalDots };
